module.exports = __webpack_public_path__ + "fonts/HalisR-S-ExtraLight.a14e58b0.otf";